<template>
    <div class="img_backgrond min-h-screen">
        <div class="flex justify-center">
            <div class="card w-full md:w-1/2 lg:w-1/3">
                <div class="card-body">
                    <h2 class="text-center">
                        <img src="@/assets/logo-180x180.png" alt="Logo" class="inline-block">
                    </h2>
                    <div 
                        class="mt-5 p-4 bg-red-500 mb-8 text-white rounded"
                        v-if="form.errors.has('credentials')"
                        v-text="form.errors.get('credentials')"
                    ></div>
                    <div 
                        class="mt-5 p-4 bg-red-500 mb-8 text-white rounded"
                        v-if="sessionExpired"
                    >Your session has expired.</div>
                    <app-input type="text"
                        v-model="form.username"
                        focus
                        placeholder="Username"
                        :error="form.errors.get('username')"
                        @updated="form.errors.clear('username')"
                        @keyup.enter.native="login"
                    ></app-input>
                    <app-input type="password"
                        v-model="form.password"
                        placeholder="Password"
                        :error="form.errors.get('password')"
                        @updated="form.errors.clear('password')"
                        @keyup.enter.native="login"
                    ></app-input>
                    <div class="form-group clearfix">
                        <div class="float-left">
                            <checkbox v-model="form.remember">Remember me</checkbox>
                        </div>
                        <router-link :to="{ name: 'password.remind' }"
                            class="float-right text-blue">Forgot Password?</router-link>
                    </div>
                    <div class="mt-6">
                        <app-button @click="login"
                            :loading="loading"
                            class="btn-blue btn-lg btn-block">Log In</app-button>
                    </div>
                </div>
            </div>
        </div>
        <app-modal
            :show.sync="showOtpModal"
            width="lg:w-1/4"
        >
            <template slot="header">One Time Password</template>
            <template slot="body">
                <app-input type="text"
                    v-model="otpForm.one_time_password"
                    focus
                    placeholder="One Time Password"
                    :error="otpForm.errors.get('one_time_password')"
                    @updated="otpForm.errors.clear('one_time_password')"
                    @keyup.enter.native="checkOTP"
                ></app-input>
                <div class="flex items-center justify-end mt-5">
                    <app-button 
                        class="btn-blue ml-2"
                        :loading="otpLoading"
                        @click="checkOTP"
                    >Submit</app-button>
                </div>
            </template>
        </app-modal>
    </div>
</template>
<script>
    import Form from '@/helpers/Form';
    import Http from '@/helpers/Http';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                form: new Form({
                    username: null,
                    password: null,
                    remember: false,
                }),
                otpForm: new Form({
                    one_time_password: null,
                    username: null,
                    password: null,
                    remember: false,
                }),
                env: process.env,
                loading: false,
                otpLoading: false,
                showOtpModal: false,
            }
        },
        computed: {
            ...mapGetters({
                sessionExpired: 'auth/sessionExpired',
            })
        },
        methods: {
            login() {
                this.loading = true
                this.form.errors.clear()
                this.$store.dispatch('auth/login', this.form.payload())
                    .then(({ data }) => {
                        this.loading = false
                        this.$store.commit('auth/sessionExpired', false);
                        
                        if (data['2fa_enabled']) {
                            this.showOtpModal = true;                            
                        } else {
                            this.$router.push({ name: 'dashboard' })
                        }
                    })
                    .catch(({ response }) => {
                        this.loading = false
                        this.form.errors.record(response.data)
                    })
            },
            checkOTP() {
                this.otpLoading = true;
                this.otpForm.errors.clear();
                this.otpForm.set({
                    username: this.form.username,
                    password: this.form.password,
                    remember: this.form.remember,
                });
                Http.post('otp/check', this.otpForm.payload())
                    .then(({data}) => {
                        this.otpLoading = false;
                        this.$store.commit('auth/login', data); 
                        this.$router.push({ name: 'dashboard' });
                    })
                    .catch(({ response }) => {
                        this.otpLoading = false;
                        this.otpForm.errors.record(response.data);
                    });
            }
        }
    }
</script>
<style scoped>
    .img_backgrond {
        background-image: url("../assets/Login-03-01.png");
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        padding: 15px;
    }
</style>